module.exports = "/assets/1107a25b423a2a1f34cdf5e883817f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SS.png
// module id = 2953
// module chunks = 0